module.exports = __webpack_public_path__ + "img/dimensionalCode.89ea8dfe.png";